
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useIsMobile } from "@/hooks/use-mobile";

export const HeroBanner = ({ onSearch }: { onSearch: (query: string) => void }) => {
  const isMobile = useIsMobile();
  
  return (
    <section className="relative overflow-hidden bg-primary text-primary-foreground">
      {/* Layered background */}
      <div className="absolute inset-0 bg-[var(--hero-gradient)]" />
      <div 
        className="absolute inset-0 bg-[url('/pattern.png')] opacity-[0.03]"
        style={{ backgroundSize: '40px 40px' }}
      />
      {/* Decorative gold accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-secondary/60 to-transparent" />
      
      <div className={`container relative mx-auto px-4 ${isMobile ? 'py-8' : 'py-12'}`}>
        <div className="max-w-2xl mx-auto text-center space-y-4 animate-fade-in">
          <div className="space-y-3">
            <p className="text-secondary font-medium tracking-[0.2em] uppercase text-xs">
              New York City
            </p>
            <h1 className={`font-display font-bold tracking-tight ${isMobile ? 'text-2xl' : 'text-4xl'} leading-[1.1]`}>
              Private Event Spaces
            </h1>
            <p className={`text-primary-foreground/60 ${isMobile ? 'text-sm' : 'text-lg'} max-w-md mx-auto font-light`}>
              Discover exceptional venues for your next celebration
            </p>
          </div>
          
          {/* Integrated search */}
          <div className="max-w-lg mx-auto pt-2">
            <div className="relative group">
              <Input
                type="text"
                placeholder="Search by name, neighborhood, or event type..."
                className="w-full pl-12 pr-4 h-12 rounded-full hero-search-input text-sm"
                onChange={(e) => onSearch(e.target.value)}
              />
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-white/40 group-focus-within:text-secondary transition-colors duration-200" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
